import { useState, useEffect } from "react";
import {
  TextField,
  IconButton,
  Box,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Search, Refresh } from "@mui/icons-material";
import moment from "moment";

const DateSearchComponentForGiftCardUser = ({ onSearch }) => {

// 4 day before 
  // ✅ Default: yesterday → today
  const [startDate, setStartDate] = useState(
    moment().subtract(4, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // ✅ Trigger default search once on mount
  useEffect(() => {
    onSearch(startDate, endDate);
  }, []); // run once

  const handleSearch = () => {
    if (startDate && endDate) {
      onSearch(startDate, endDate);
    }
  };

  const handleReset = () => {
    const defaultStartDate = moment().subtract(4, "days").format("YYYY-MM-DD");
    const defaultEndDate = moment().format("YYYY-MM-DD");
    setStartDate(defaultStartDate);
    setEndDate(defaultEndDate);
    onSearch(defaultStartDate, defaultEndDate);
  };

  return (
    <Box
      display="flex"
      alignItems={isMobile ? "stretch" : "center"}
      justifyContent={isMobile ? "flex-start" : "flex-end"}
      gap={isMobile ? 0.5 : 1}
    >
      {/* Start Date */}
      <TextField
        name="startDate"
        id="startDate"
        size="small"
        label="Start Date"
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        variant="outlined"
        fullWidth={isMobile}
      />

      {/* End Date */}
      <TextField
        size="small"
        name="endDate"
        id="endDate"
        label="End Date"
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        variant="outlined"
        fullWidth={isMobile}
      />

      {/* Buttons */}
      <Box
        display="flex"
        flexDirection="row"
        justifyContent={isMobile ? "flex-end" : "center"}
        gap={isMobile ? 0.5 : 0}
      >
        <Tooltip title="Search">
          <IconButton
            color="primary"
            onClick={handleSearch}
            size={isMobile ? "small" : "medium"}
            sx={{ p: isMobile ? "0px" : "4px" }}
          >
            <Search />
          </IconButton>
        </Tooltip>

        <Tooltip title="Reset">
          <IconButton
            color="secondary"
            onClick={handleReset}
            size={isMobile ? "small" : "medium"}
            sx={{ p: isMobile ? "0px" : "4px" }}
          >
            <Refresh />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default DateSearchComponentForGiftCardUser;

